import { breakpoints } from '@uds/theme-utils';
import { useCallback, useState, useEffect } from 'react';
import { useWindow } from '@uds/hooks';

const ucfirst = str => str.charAt(0).toUpperCase() + str.slice(1);
const useMatchMedia = breakpoints => {
  const window = useWindow();
  const getValues = useCallback(() => {
    // see which breakpoint queries are true
    return Object.keys(breakpoints).reduce((prev, cur) => {
      return {
        ...prev,
        [`isMin${ucfirst(cur)}`]: window.matchMedia(`(min-width: ${breakpoints[cur]}px)`).matches
      };
    }, {});
  }, [breakpoints, window]);
  const [values, setValues] = useState(getValues);
  useEffect(() => {
    const handler = () => setValues(getValues);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [getValues, window]);
  return values;
};
var useMatchMedia$1 = useMatchMedia;

const useBreakpoints = () => {
  return useMatchMedia$1(breakpoints);
};
var useBreakpoints$1 = useBreakpoints;

export { useBreakpoints$1 as useBreakpoints };
